import aiToolsTheme from './aiToolsTheme';

export { aiToolsTheme };

export default aiToolsTheme;
